export default __webpack_public_path__ + "static/media/video.be58f90b.mp4";